import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Eye, BarChart2 } from 'lucide-react';
export function Slide3BrandEngagement() {
  const whyMatters = ['Deep brand penetration with decision-makers', 'Positive peer association, not a sales pitch', 'Extended brand recall from sustained engagement', 'Thought leadership positioning as an insights provider'];
  return <div className="flex flex-col h-full max-w-[1700px] mx-auto w-full" data-id="element-578">
      <div className="mb-8 border-b border-slate-100 pb-6" data-id="element-579">
        <div className="text-sm font-bold text-snakker-purple uppercase tracking-widest mb-2" data-id="element-580">
          03 / Brand Engagement
        </div>
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-2" data-id="element-581">
          Exceptional Market Presence
        </h2>
        <p className="text-xl text-slate-500 max-w-4xl" data-id="element-582">
          Minerva generated outsized market attention, outperforming larger
          competitors on engagement efficiency.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 flex-1 items-stretch" data-id="element-583">
        {/* Depth */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-3xl p-6 border border-slate-100 shadow-sm col-span-1 lg:col-span-2" data-id="element-584">
          <div className="flex items-center gap-3 mb-6" data-id="element-585">
            <div className="p-2.5 bg-minerva-blue/10 rounded-xl" data-id="element-586">
              <Clock className="w-5 h-5 text-minerva-blue" data-id="element-587" />
            </div>
            <h3 className="text-xl font-bold text-slate-800" data-id="element-588">
              Unmatched Engagement Depth
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-589">
            <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100 flex flex-col justify-center items-center text-center" data-id="element-590">
              <div className="text-5xl font-bold text-minerva-dark mb-2" data-id="element-591">
                4.5 min
              </div>
              <div className="text-sm font-bold text-slate-500 uppercase tracking-wider mb-3" data-id="element-592">
                Average Engagement
              </div>
              <div className="inline-flex items-center gap-1.5 bg-minerva-blue/10 text-minerva-blue font-bold text-xs px-3 py-1.5 rounded-full" data-id="element-593">
                4.5x longer than industry avg
              </div>
            </div>

            <div className="flex flex-col justify-center space-y-4" data-id="element-594">
              <div className="flex items-start gap-3" data-id="element-595">
                <Eye className="w-5 h-5 text-minerva-blue shrink-0 mt-0.5" data-id="element-596" />
                <p className="text-slate-700 text-sm font-medium" data-id="element-597">
                  73 Total Brand Exposures across a highly qualified audience
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-598">
                <Eye className="w-5 h-5 text-minerva-blue shrink-0 mt-0.5" data-id="element-599" />
                <p className="text-slate-700 text-sm font-medium" data-id="element-600">
                  Participants spent extended time with Minerva messaging
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-601">
                <Eye className="w-5 h-5 text-minerva-blue shrink-0 mt-0.5" data-id="element-602" />
                <p className="text-slate-700 text-sm font-medium" data-id="element-603">
                  Zero drop-off on explicitly branded content
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Why it matters */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-minerva-dark rounded-3xl p-6 border border-minerva-blue/20 shadow-lg text-white flex flex-col" data-id="element-604">
          <div className="flex items-center gap-3 mb-6" data-id="element-605">
            <div className="p-2.5 bg-white/10 rounded-xl" data-id="element-606">
              <BarChart2 className="w-5 h-5 text-minerva-cyan" data-id="element-607" />
            </div>
            <h3 className="text-xl font-bold text-white" data-id="element-608">Why This Matters</h3>
          </div>

          <div className="space-y-4 flex-1" data-id="element-609">
            {whyMatters.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-610">
                <div className="w-1.5 h-1.5 rounded-full bg-minerva-cyan mt-2 shrink-0 shadow-[0_0_8px_rgba(0,255,255,0.5)]" data-id="element-611" />
                <p className="text-white/90 text-sm font-medium leading-relaxed" data-id="element-612">
                  {item}
                </p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </div>;
}